import {ModalController} from '../../../../../modules/core/abstracts/controllers/modal-controller';

class SplitVoucherModalController extends ModalController {
    constructor($uibModalInstance, SweetAlert, $http, $scope, voucherToSplit) {
        super($uibModalInstance);
        this.sweetAlert = SweetAlert;
        this.api = $http;
        this.scope = $scope;
        this.voucherToSplit = voucherToSplit;
        this.blockSubmit = true;
        this.submitBlockReason = '';

        this.dataToSend = {
            state: false
        };

        this.initWatchers();
        this.newVouchers = [];
        this.addVouchers(2);
    }

    initWatchers() {
        this.scope.$watch(() => {
            return this.newVouchers;
        }, () => {
            this.validateCurrentVouchers();
        }, true);
    }

    validateCurrentVouchers() {
        this.submitBlockReason = '';
        this.blockSubmit = false;

        if (this.newVouchers.length < 2) {
            this.submitBlockReason = 'You must split the voucher at least in 2 new vouchers';
            this.blockSubmit = true;
            return;
        }

        let completeSum = 0.0;

        let singleError = false;
        _.each(this.newVouchers, (newVoucher) => {
            if(newVoucher.amount <= 0) {
                this.submitBlockReason = 'All vouchers must have an amount larger than 0';
                this.blockSubmit = true;
                singleError = true;
                return;
            }
            completeSum = completeSum + newVoucher.amount;
        });
        if(singleError) {
            return;
        }

        if (parseFloat(completeSum.toFixed(2)) !== this.voucherToSplit.amount) {
            this.submitBlockReason = 'The sums do not match with the voucher to split';
            this.blockSubmit = true;
            return;
        }

        this.blockSubmit = false;
    }

    addVouchers(countToAdd) {
        for (let i = 0; i < countToAdd; i++) {
            this.newVouchers.push({
                amount: 0,
                name: ''
            });
        }

        this.resetNewVoucherAmounts();
    }

    removeVoucher(voucher) {
        const index = this.newVouchers.indexOf(voucher);

        if(index > -1) {
            this.newVouchers.splice(index, 1);
            this.resetNewVoucherAmounts();
        }
    }

    resetNewVoucherAmounts() {
        let amountForEachVoucher = parseFloat((this.voucherToSplit.amount / this.newVouchers.length).toFixed(2)),
            amountForNextVoucher = parseFloat((this.voucherToSplit.amount - (amountForEachVoucher * (this.newVouchers.length - 1))).toFixed(2));

        _.each(this.newVouchers, (newVoucher) => {
            newVoucher.amount = amountForNextVoucher;
            amountForNextVoucher = amountForEachVoucher;
        });
    }

    save() {
        this.api.post(`vouchers/${this.voucherToSplit.id}/split`, {
            vouchers: this.newVouchers
        }).then(() => {
            this.dataToSend.state = true;
            this.close();
        }, () => {
            this.dataToSend.state = false;
            this.close();
        });
    }
}

SplitVoucherModalController.$inject = [
    '$uibModalInstance',
    'SweetAlert',
    '$http',
    '$scope',
    'voucherToSplit'
];


angular
    .module('festzelt-os.vouchers.main')
    .controller('SplitVoucherModalController', SplitVoucherModalController);



// WEBPACK FOOTER //
// ./src/app/pages/vouchers/main/controllers/modals/split-voucher-modal-controller.js